import React from "react";
import { skills } from "../data/data";
import { useI18n } from "../i18n";

export const Skills = () => {
  const { t } = useI18n();

  return (
    <>
      <div className="skills-title-container">
        <h3 className="skills-title">{t.about.skillsTitle}</h3>
        <div className="skills-line"></div>
      </div>

      {/* skills-center */}
      <div className="skills-center">
        {skills.map(({ id, title, icon }) => {
          return (
            <article key={id} className="skill" title={title}>
              <img
                src={icon}
                alt={title}
                className="skill-icon"
                width="48"
                height="48"
                loading="lazy"
              />
            </article>
          );
        })}
      </div>
    </>
  );
};
